import React, { useEffect } from 'react'
import { GoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useLocation, useRoutes } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import autocallRoutes from '@/routes'
import { RecapAuthToken, RefreshRecapAuthToken, ServiceCancel } from '@/shared/recoil/common/atom'

const App = () => {
  const location = useLocation()
  const element = useRoutes(autocallRoutes)
  const setAuthToken = useSetRecoilState(RecapAuthToken)
  const refreshReCaptcha = useRecoilValue(RefreshRecapAuthToken)
  const setServiceCancel = useSetRecoilState(ServiceCancel)

  const handleVerify = (value: any) => {
    setAuthToken(value)
  }

  useEffect(() => {
    if (window.location.hostname.includes('servicecancel')) {
      setServiceCancel(true)
    } else {
      setServiceCancel(false)
    }
  }, [setServiceCancel])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <div className="app">
      <Sentry.ErrorBoundary>{element}</Sentry.ErrorBoundary>
      <GoogleReCaptcha onVerify={handleVerify} refreshReCaptcha={refreshReCaptcha} />
    </div>
  )
}

export default App
